import React, { useState } from "react";
import { Card, Table, Form, Button } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { BsCircleFill } from "react-icons/bs";
import EditHolidayModal from "../../components/modals/hrm/holidays/EditHolidayModal";
import DeleteModal from "../../components/modals/hrm/holidays/DeleteModal";
import HolidaysHeader from "../../components/hrm/holidays/HolidaysHeader";


const initialData = [
  {
    id: 1,
    title: "New Year",
    date: "01 Jan 2024",
    description: "First day of the new year",
    status: "Active",
  },
  {
    id: 2,
    title: "Martin Luther King Jr. Day",
    date: "15 Jan 2024",
    description: "Celebrating the civil rights leader",
    status: "Active",
  },
  {
    id: 3,
    title: "President's Day",
    date: "19 Feb 2024",
    description: "Honoring past US Presidents",
    status: "Active",
  },
  {
    id: 4,
    title: "Good Friday",
    date: "29 Mar 2024",
    description: "Holiday before Easter",
    status: "Active",
  },
  {
    id: 5,
    title: "Easter Monday",
    date: "01 Apr 2024",
    description: "Holiday after Easter",
    status: "Active",
  },
  {
    id: 6,
    title: "Memorial Day",
    date: "27 May 2024",
    description: "Honors military personnel",
    status: "Active",
  },
  {
    id: 7,
    title: "Independence Day",
    date: "04 Jul 2024",
    description: "Celebrates Independence",
    status: "Active",
  },
  {
    id: 8,
    title: "Labour Day",
    date: "02 Sep 2024",
    description: "Honors working people",
    status: "Inactive",
  },
  {
    id: 9,
    title: "Veterans Day",
    date: "11 Nov 2024",
    description: "Honors military veterans",
    status: "Active",
  },
  {
    id: 10,
    title: "Christmas Day",
    date: "25 Dec 2024",
    description: "Celebration of Christmas",
    status: "Active",
  },
  {
    id: 11,
    title: "Republic Day",
    date: "26 Jan 2024",
    description: "Celebration of the Constitution of India",
    status: "Active",
  },
  {
    id: 12,
    title: "Maha Shivaratri",
    date: "08 Mar 2024",
    description: "Hindu festival dedicated to Lord Shiva",
    status: "Active",
  },
  {
    id: 13,
    title: "Holi",
    date: "25 Mar 2024",
    description: "Festival of colors",
    status: "Active",
  },
  {
    id: 14,
    title: "Ram Navami",
    date: "17 Apr 2024",
    description: "Celebrates birth of Lord Rama",
    status: "Active",
  },
  {
    id: 15,
    title: "Bakrid / Eid al-Adha",
    date: "17 Jun 2024",
    description: "Festival of sacrifice",
    status: "Active",
  },
  {
    id: 16,
    title: "Independence Day (India)",
    date: "15 Aug 2024",
    description: "Celebrates India's independence",
    status: "Active",
  },
  {
    id: 17,
    title: "Ganesh Chaturthi",
    date: "07 Sep 2024",
    description: "Festival honoring Lord Ganesha",
    status: "Active",
  },
  {
    id: 18,
    title: "Dussehra",
    date: "12 Oct 2024",
    description: "Victory of good over evil",
    status: "Active",
  },
  {
    id: 19,
    title: "Diwali",
    date: "01 Nov 2024",
    description: "Festival of lights",
    status: "Active",
  },
  {
    id: 20,
    title: "Christmas Eve",
    date: "24 Dec 2024",
    description: "Day before Christmas celebration",
    status: "Inactive",
  },
];

const HolidaysPage = () => {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);

  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);

  const filtered = data
    .filter(
      (item) =>
        item.title.toLowerCase().includes(search.toLowerCase()) ||
        item.description.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, rows);

  return (
    <>
<div  
style={{ padding: "15px", background: "#f8f9fa",  }}  >
         <HolidaysHeader/>
      <Card style={{ border: "1px solid #e5e7eb", borderRadius: "8px" }}>
        
        {/* HEADER */}
        {/* <div >
    
        </div> */}
            <h5  style={{ padding: "9px", }}>  Holidays List</h5>
<hr />
        {/* FILTER */}
        <div
          style={{
            padding: "1px 16px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            Row Per Page
            <Form.Select
              style={{ width: "70px" }}
              value={rows}
              onChange={(e) => setRows(Number(e.target.value))}
            >
              <option>5</option>
              <option>10</option>
              <option>20</option>
            </Form.Select>
            Entries
          </div>

          <Form.Control
            placeholder="Search"
            style={{ width: "200px" }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* TABLE */}
        <div style={{ overflowX: "auto" }}>
          <Table hover style={{ marginBottom: 0 }}>
            <thead style={{ background: "#f9fafb" }}>
              <tr>
                <th><Form.Check /></th>
                <th>Title</th>
                <th>Date</th>
                <th>Description</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr key={item.id}>
                  <td><Form.Check /></td>

                  <td style={{ fontWeight: 500 }}>{item.title}</td>

                  <td>{item.date}</td>

                  <td style={{ color: "#6b7280" }}>
                    {item.description}
                  </td>

                  {/* STATUS */}
                  <td>
                    <span
                      style={{
                        background:
                          item.status === "Active" ? "#16a34a" : "#dc2626",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <BsCircleFill size={6} />
                      {item.status}
                    </span>
                  </td>

                  {/* ACTION */}
                  <td>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <FiEdit2
                        style={{ cursor: "pointer" }}
                        onClick={() => setEditItem(item)}
                      />
                      <FiTrash2
                        style={{ cursor: "pointer" }}
                        onClick={() => setDeleteItem(item)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* EDIT MODAL */}
      {editItem && (
        <EditHolidayModal
          show={true}
          data={editItem}
          handleClose={() => setEditItem(null)}
          handleSave={(updated) => {
            setData((prev) =>
              prev.map((i) => (i.id === updated.id ? updated : i))
            );
            setEditItem(null);
          }}
        />
      )}

      {/* DELETE MODAL */}
      {deleteItem && (
        <DeleteModal
          show={true}
          handleClose={() => setDeleteItem(null)}
          handleDelete={() => {
            setData((prev) =>
              prev.filter((i) => i.id !== deleteItem.id)
            );
            setDeleteItem(null);
          }}
        />
      )}
</div>
    </>
  );
};

export default HolidaysPage;